export default "__VITE_ASSET__wWazkhe7__"